module.exports = __webpack_public_path__ + "static/media/introScreenIcon.6815629f.png";